<template lang="pug">
  v-navigation-drawer.primary(
    v-model="drawer"
    app
    dark
    clipped
    fixed
    width="250"
  )
    .white.text-center
      img.mx-auto.my-3(:src="tenantLogoImage" width="180")

    v-list.mt-10(expand)
      template(v-for="(item,i) in sidebarMenus")
        v-list-group(
          v-if="!item.hidden && item.children && item.children.length > 0"
          :key="i"
          :no-action="true"
          :color="`white`"
          :value="getActiveClass(item) !== ''"
        )
          v-list-item.px-0(slot="activator")
            v-list-item-content(@click="gotoRoute(item.name)")
              v-list-item-title {{ item.text }}

          template(v-for="subItem in item.children")
            v-list-item(
              v-if="!subItem.hidden"
              :class="getActiveClass(subItem)"
              :key="subItem.title"
              :to="{ name: subItem.name }"
              :append="true"
              :exact="true"
            )
              v-list-item-content
                v-list-item-title
                  span(:id="getItemId(subItem)") {{ subItem.text }}

        template(v-else-if="!item.hidden")
          v-list-item(
            v-if="item.name === 'analyse'"
            :class="getActiveClass(item)"
            :key="i"
            :append="true"
            @click="gotoRoute(item.name)"
          )
            v-list-item-content: v-list-item-title
              span(:id="getItemId(item)") {{ item.text }}

          v-list-item(
            v-else
            :class="getActiveClass(item)"
            :key="i"
            :to="{ name: item.name }"
            :append="true"
            :exact="true"
          )
            v-list-item-content: v-list-item-title
              span(:id="getItemId(item)") {{ item.text }}
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'

import AuthMixin from '@/mixins/auth'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    AuthMixin,
    FormMixin
  ],

  computed: mapGetters([
    'sidebarVisible',
    'userTenantId'
  ]),

  methods: mapActions([
    'setSidebarVisible'
  ])
})
export default class NavigationBar extends Vue {
  @Watch('drawer')
  onSetSidebarVisible () {
    this.setSidebarVisible(this.drawer)
  }

  @Watch('sidebarVisible')
  onSetDrawer () {
    this.drawer = this.sidebarVisible
  }

  drawer = true

  get tenantLogoImage () {
    if (this.userTenantId === 'FSOEL') {
      return require('@/assets/images/fsoel_logo.svg')
    } else if (this.userTenantId === 'SAV') {
      return require('@/assets/images/sav_logo.svg')
    }

    return require('@/assets/images/vkb_logo.svg')
  }

  get sidebarMenus () {
    return [
      {
        text: 'Administration',
        hidden: !this.isAdmin,
        children: [
          {
            text: 'Benutzerverwaltung',
            name: 'user-list',
          },
          {
            text: 'Agenturen',
            name: 'agency-list'
          },
        ],
      },
      {
        text: 'Statistik',
        name: 'statistics',
        hidden: !this.isSuperAdmin,
      },
      {
        text: 'Mein Profil',
        name: 'profile'
      },
      {
        text: 'Agentur wählen',
        name: 'agency-select',
        hidden: this.agencies.length <= 1
      },
      {
        text: 'Kunden wählen',
        name: 'company-list',
        hidden: !this.selectedAgency
      },
      // {
      //   text: 'Beratung',
      //   hidden: !this.selectedCompany,
      //   children: [
      //     {
      //       text: 'Liste Beratungen',
      //       name: 'consultation-list',
      //     },
      //   ],
      // },
      {
        text: 'Kunden-Beratungen',
        hidden: !this.selectedCompany,
        name: 'consultation-list'
      },
      {
        text: 'Rimas-Light',
        hidden: !this.selectedCompany,
        name: 'rimas-light-list'
      },
      {
        text: 'Info',
        name: 'service'
      },
      {
        text: 'WIN- / LOSS-Analyse',
        name: 'analyse'
      }
    ]
  }

  getItemId (item) {
    let id = item.name

    if (item.params) {
      const params = Object.keys(item.params).map(k => item.params[k]).join('-')
      id = `${ id }-${ params }`
    }
    return id
  }

  getActiveClass (item) {
    let activeClass = ''

    if (item.name !== this.$route.name) {
      if (item.children) {
        activeClass = item.children.map(c => this.getActiveClass(c)).join('')
      }
      return activeClass
    }

    let bSelected = true

    if (item.params) {
      Object.keys(this.$route.params)
        .map(key => {
          if (item.params[key] !== this.$route.params[key]) {
            bSelected = false
          }
        })
    }

    if (bSelected) {
      activeClass = 'nav-item--active'

      setTimeout(() => {
        this.updateScrollPosition(item)
      }, 300)
    }
    return activeClass
  }

  getElementTop (element) {
    if (!element) {
      return 0
    }

    let top = 0

    do {
      top += element.offsetTop || 0
      element = element.offsetParent
    } while (element)

    return top
  }

  updateScrollPosition (item) {
    const id = this.getItemId(item)
    const excludeIds = [ '' ]

    if (!id || excludeIds.includes(id)) {
      return
    }

    const scrollWrapper = document.getElementsByClassName('v-navigation-drawer__content')[0]
    const selectedElement = document.getElementById(id)

    if (!scrollWrapper) {
      return
    }

    let scrollTop = scrollWrapper.clientHeight + scrollWrapper.scrollTop
    let elementTop = this.getElementTop(selectedElement)
    let scrollOffsetY = 0

    elementTop = elementTop - scrollWrapper.offsetTop // 48 is height of nav item

    if (elementTop > scrollTop) {
      scrollOffsetY = scrollWrapper.scrollTop + (elementTop - scrollTop)
      scrollWrapper.scrollTo(0, scrollOffsetY + scrollWrapper.clientHeight / 2)
    } else if (elementTop < scrollWrapper.scrollTop) {
      scrollOffsetY = scrollWrapper.scrollTop - elementTop
      scrollWrapper.scrollTo(0, scrollOffsetY - scrollWrapper.clientHeight / 2)
    }
  }
}
</script>
